module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIuNjEgNTEyLjYxIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZkYjcxNDt9LmNscy0ye2ZpbGw6IzBiMGQxNTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnphcC12MjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyNTYuMyIgY3k9IjI1Ni4zIiByPSIyNTYuMyIvPjxwYXRoIGNsYXNzPSJjbHMtMiIgZD0iTTI3Ni45MiwyMzQuN2g4MC41MUwxNzQuOTQsNDE3LjE5bDYwLjEzLTE0MC4zOEgxNTUuMThMMzM2LjU3LDk1LjQyWiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/content/images/zap-v2.svg
// module id = 526
// module chunks = 114276838955818